jQuery( document ).ready( function ( $ ) {
  // Your site's jQuery goes inside this .ready() function.

  // Splitting JS Init
  Splitting();

  /******************************************************
    Setting handy CSS Variables
  *******************************************************/
  // Slight fix for VH units, particularly for mobile browsers
  var inHeight = window.innerHeight / 100;​
  document.documentElement.style.setProperty( "--vh", inHeight + "px" );
  $( window ).resize( function ( event ) {
    var inHeight = window.innerHeight / 100;
    document.documentElement.style.setProperty( "--vh", inHeight + "px" );
  } );

  /******************************************************
    Animation Library / Area - Scroll Magic + GSAP
  *******************************************************/
  var smcontroller = new ScrollMagic.Controller();​
  $( ".line-fade" ).each( function () {
    var me = $( this );
    var lineFader = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: 1
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "show" );
      } )
      //.addIndicators()
      .addTo( smcontroller );
  } );​
  $( '.line-fade-rev' ).each( function () {
    var me = $( this );
    var showFromLeft = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: 1,
        duration: '88%',
        reverse: true
      } )
      .setClassToggle( this, "show" )
      .addTo( smcontroller );
  } );
  $( ".fade-in" ).each( function () {
    var me = $( this );
    var showFromBottom = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: .95
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "show" );
      } )
      .addTo( smcontroller );
  } );​
  $( ".fade-in-up" ).each( function () {
    var me = $( this );
    var showFromBottom = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: .95
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "show" );
      } )
      .addTo( smcontroller );
  } );​

  /*****************************************************************
    For when we do a img src="example.svg" SVG use instead of the 
    <svg> html markup
  ******************************************************************/
  ​
  $( "img.svg" ).each( function () {
    var $img = $( this );
    var imgID = $img.attr( "id" );
    var imgClass = $img.attr( "class" );
    var imgURL = $img.attr( "src" );​
    $.get(
      imgURL,
      function ( data ) {
        // Get the SVG tag, ignore the rest
        var $svg = $( data ).find( "svg" );​
        // Add replaced image's ID to the new SVG
        if ( typeof imgID !== "undefined" ) {
          $svg = $svg.attr( "id", imgID );
        }
        // Add replaced image's classes to the new SVG
        if ( typeof imgClass !== "undefined" ) {
          $svg = $svg.attr( "class", imgClass + " replaced-svg" );
        }​
        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr( "xmlns:a" );​
        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (
          !$svg.attr( "viewBox" ) &&
          $svg.attr( "height" ) &&
          $svg.attr( "width" )
        ) {
          $svg.attr(
            "viewBox",
            "0 0 " + $svg.attr( "height" ) + " " + $svg.attr( "width" )
          );
        }​
        // Replace image with new SVG
        $img.replaceWith( $svg );
      },
      "xml"
    );
  } );​

  $( "#keep-moving" ).replaceWith(
    '<a href="https://themovetic.com/" target="_blank">Site by <span class="m-logo"></span></a>'
  );​

  // 3D flipbook plugin loads an old version of font awesome.
  // We remove it here.
  $( "#font_awesome-css" ).remove();

  /******************************************************
    The Menu Button display and hide Nav functionality
  *******************************************************/
  $( ".open-menu-btn, .close-menu-btn" ).click( function ( e ) {
    e.preventDefault();
    $( "nav" ).toggleClass( "active-nav" );
  } );


  /******************************************************************************************************
    Detect Scroll Direction
  *******************************************************************************************************/
  var lastScrollTop = 0;

  window.addEventListener("scroll", function(){
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop){
        $('body').addClass('scroll-down');
      } else {
        $('body').removeClass('scroll-down');
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }, false);

  /******************************************************************************************************
    Adds a slight background to the menu bar on scroll
  *******************************************************************************************************/

  if ($('.live-auction-banner').length) {
    var $banner =$('.live-auction-banner'),
    banner_height = $banner.outerHeight(),
    $top_header =$('.top-header');
    $top_header.css({marginTop: banner_height + 'px'});
  }

  $( window ).scroll( function () {
    var x = $( window ).scrollTop();
    //>=, not <=
    if ( x >= 100 ) {
      $( ".top-header" ).addClass( "header-bg" );
    } else {
      $( ".top-header" ).removeClass( "header-bg" );
    }

    if ( $( ".scroll-nav" ) ) {
      var y = $( ".page-header-section" ).height() - 200;
      var z =
        $( document ).height() -
        ( $( ".section-seven" ).height() +
          $( "footer" ).height() +
          $( window ).height() );

      if ( x >= y ) {
        if ( x >= z ) {
          $( ".scroll-nav" ).removeClass( "show-sidenav" );
        } else {
          $( ".scroll-nav" ).addClass( "show-sidenav" );
        }
      } else {
        $( ".scroll-nav" ).removeClass( "show-sidenav" );
      }
    }
  } );


  $(".nav.navbar-nav").scrollspy({ offset: -75 });

  /******************************************************************************************************
    Sidenav jump to new section smoothly
  *******************************************************************************************************/

  $( ".scroll-nav ul li a" ).click( function ( e ) {
    e.preventDefault();

    sidenavJump = $( this ).attr( "href" );
    $( "html, body" ).animate( { scrollTop: $( sidenavJump ).offset().top } );
  } );

  /******************************************************************************************************
    The Frontpage.php functionality for when a box is hovered show the image that corresponds with it.
  *******************************************************************************************************/

  $( ".market" ).hover(
    function () {
      $( ".market-img" ).css( "display", "block" );
    },
    function () {
      $( ".market-img" ).css( "display", "none" );
    }
  );

  $( ".success" ).hover(
    function () {
      $( ".success-img" ).css( "display", "block" );
    },
    function () {
      $( ".success-img" ).css( "display", "none" );
    }
  );

  $( ".buying" ).hover(
    function () {
      $( ".buying-img" ).css( "display", "block" );
    },
    function () {
      $( ".buying-img" ).css( "display", "none" );
    }
  );

  $( ".selling" ).hover(
    function () {
      $( ".selling-img" ).css( "display", "block" );
    },
    function () {
      $( ".selling-img" ).css( "display", "none" );
    }
  );

  /*****************************************************************************************************
    The Scroll Down arrow button/img on the blue header section for pages to jump page down smoothly.
  ******************************************************************************************************/
  $( "#show-content" ).click( function ( e ) {
    e.preventDefault();
    var nextSection = $( this )
      .closest( "section" )
      .next();
    $( "html, body" ).animate( { scrollTop: nextSection.offset().top } );
    return false;
  } );

  /*****************************************************************************************************
    Mobile hover fix for iOS devices + other mobile device scrolls
  ******************************************************************************************************/

  $( "*" )
    .on( "touchstart", function () {
      $( this ).trigger( "hover" );
    } )
    .on( "touchend", function () {
      $( this ).trigger( "hover" );
    } );

  /*****************************************************************************************************
    Tabination on the Selling Page for the 7 Reasons section.
  ******************************************************************************************************/
  $( ".tab-nav a" ).click( function ( e ) {
    e.preventDefault();
    var tabs = $( ".tab-nav" ).children(),
      descs = $( ".tab-desc" ).children(),
      clickedTab = $( this ),
      i = clickedTab.index(),
      newDesc = descs[ i ];

    tabs.removeClass( "activenav" );
    descs.removeClass( "activedesc" );
    clickedTab.addClass( "activenav" );
    $( newDesc ).addClass( "activedesc" );
  } );

  /*****************************************************************************************************
    Selling page video modal popup
  ******************************************************************************************************/

  /*$(".open-modal").click(function(e) {
    e.preventDefault();
    var video = $("#playvideo").attr("src");
    video = video.replace("?autoplay=0", "?autoplay=1");
    $("#playvideo").attr("src", video);
    $(".modal-overlay").css("display", "block");
  });

  $(".close-modal, .modal-overlay").click(function(e) {
    e.preventDefault();
    var video = $("#playvideo").attr("src");
    video = video.replace("?autoplay=1", "?autoplay=0");
    $("#playvideo").attr("src", "");
    $("#playvideo").attr("src", video);
    $(".modal-overlay").css("display", "none");
  });*/

  /*****************************************************************************************************
    The Word Filter code for Glossary Page which can easily filter the content according to word
  ******************************************************************************************************/
  $(".demoTwo").listnav({
    includeAll: false,
    noMatchText: "There are no matching entries."
  });
  $(".demo a").click(function(e) {
    e.preventDefault();
  });

  /*****************************************************************************************************
    All, Selling And Buying Category filter by using ajax code 
  ******************************************************************************************************/
  $( "#all" ).addClass( "active" );
  $( "#filtersFAQ .filterFAQ" ).click( function () {
    $( "#filtersFAQ .filterFAQ" ).removeClass( "active" );
    $( this ).addClass( "active" );
    var filter = $( this ).attr( "id" );
    $( "#isotope ul li" ).show();
    $( "#isotope ul li:not(." + filter + ")" ).hide();
  } );

  /***********************************************************************************/
  // To keep our code clean and modular, all custom functionality will be contained inside a single object literal called "buttonFilter".

  var buttonFilter = {
    // Declare any variables we will need as properties of the object

    $filters: null,
    $reset: null,
    groups: [],
    outputArray: [],
    outputString: "",

    // The "init" method will run on document ready and cache any jQuery objects we will need.

    init: function () {
      var self = this; // As a best practice, in each method we will asign "this" to the variable "self" so that it remains scope-agnostic. We will use it to refer to the parent "buttonFilter" object so that we can share methods and properties between all parts of the object.

      self.$filters = $( "#Filters" );
      self.$reset = $( "#Reset" );
      self.$container = $( "#filterContainer" );

      self.$filters.find( "fieldset" ).each( function () {
        self.groups.push( {
          $buttons: $( this ).find( ".filter" ),
          active: ""
        } );
      } );

      self.bindHandlers();
    },

    // The "bindHandlers" method will listen for whenever a button is clicked.

    bindHandlers: function () {
      var self = this;

      // Handle filter clicks

      self.$filters.on( "click", ".filter", function ( e ) {
        e.preventDefault();

        var $button = $( this );

        // If the button is active, remove the active class, else make active and deactivate others.

        $button.hasClass( "active" ) ?
          $button.removeClass( "active" ) :
          $button
          .addClass( "active" )
          .siblings( ".filter" )
          .removeClass( "active" );

        self.parseFilters();
      } );

      // Handle reset click

      self.$reset.on( "click", function ( e ) {
        e.preventDefault();

        self.$filters.find( ".filter" ).removeClass( "active" );
        self.$filters.find( ".show-all" ).addClass( "active" );

        self.parseFilters();
      } );
    },

    // The parseFilters method checks which filters are active in each group:

    parseFilters: function () {
      var self = this;

      // loop through each filter group and grap the active filter from each one.

      for ( var i = 0, group;
        ( group = self.groups[ i ] ); i++ ) {
        group.active =
          group.$buttons.filter( ".active" ).attr( "data-filter" ) || "";
      }

      self.concatenate();
    },

    // The "concatenate" method will crawl through each group, concatenating filters as desired:

    concatenate: function () {
      var self = this;

      self.outputString = ""; // Reset output string

      for ( var i = 0, group;
        ( group = self.groups[ i ] ); i++ ) {
        self.outputString += group.active;
      }

      // If the output string is empty, show all rather than none:

      !self.outputString.length && ( self.outputString = "all" );

      console.log( self.outputString );

      // ^ we can check the console here to take a look at the filter string that is produced

      // Send the output string to MixItUp via the 'filter' method:

      if ( self.$container.mixItUp( "isLoaded" ) ) {
        self.$container.mixItUp( "filter", self.outputString );
      }
    }
  };

  /******************************************************************************
   *******************    Live Event Page                 ***********************
   ******************************************************************************/
  $( "#owl-seller-testimonials" ).owlCarousel( {
    autoplay: true,
    singleItem: true,
    items:1,
    slideSpeed: 500,
    rewindSpeed: 500,
    nav: true,
    loop: true,
    navText: [
      "<span class='fa fa-chevron-left'></span>",
      "<span class='fa fa-chevron-right'></span>"
    ],
    pagination: true,
    responsiveRefreshRate: 200
  } );

  /******************************************************************************
   *******************    About Us Page                 ***********************
   ******************************************************************************/
  if ( $( ".about-images" ) ) {
    $( ".about-images" ).owlCarousel( {
      singleItem: true,
      items: 1,
      slideSpeed: 500,
      rewindSpeed: 500,
      navigation: true,
      loop: true,
      nav: true,
      navText: [
        '<button class="btnleft" title="Left Arrow"><img src="/wp-content/themes/harcourts/assets/images/left_arrow.png" alt="Left Arrow"></button>',
        '<button class="btnright" title="Right Arrow"><img src="/wp-content/themes/harcourts/assets/images/right_arrow.png" alt="Right Arrow"></button>'
      ]
    } );
  }

  /*******************************************************************************
   *******************    Live Single Event Page                 *****************
   *******************************************************************************/
  $( "#owl-properties" ).owlCarousel( {
    items: 3,
    itemsDesktop: [ 1000, 3 ], //5 items between 1000px and 901px
    itemsDesktopSmall: [ 900, 2 ], // betweem 900px and 601px
    Tableitemst: [ 600, 1 ], //2 items between 600 and 0;
    itemsMobile: false, // itemsMobile disabled - inherit from itemsTablet option
    autoplay: false,
    navigation: true,
    loop: true,
    navigationText: [
      "<span class='fa fa-chevron-left'></span>",
      "<span class='fa fa-chevron-right'></span>"
    ],
    pagination: true,
    responsiveRefreshRate: 200
  } );

  /******************************************************************************
   *****    About Us Page, TEAM section functionalities                 ********
   ******************************************************************************/
  $( ".team-member" ).click( function ( e ) {
    e.preventDefault();

    var tabs = $( ".team-grid" ).children(),
      modals = $( ".team-modal" ).children(),
      clickedTab = $( this ),
      i = clickedTab.index(),
      activeModal = modals[ i ];

    tabs.removeClass( "active" );
    modals.removeClass( "active" );
    clickedTab.addClass( "active" );
    $( activeModal ).addClass( "active" );

    if ( $( this ).index() == 0 ) {
      $( ".modalnav .leftbtn" ).css( "opacity", ".25" );
    } else if ( $( this ).index() == $( ".team-modal" ).children().length - 1 ) {
      $( ".modalnav .rightbtn" ).css( "opacity", ".25" );
    } else {
      $( ".modalnav .leftbtn" ).css( "opacity", "1" );
      $( ".modalnav .rightbtn" ).css( "opacity", "1" );
    }

    $( "body" ).addClass( "noscroll" );
    $( ".modal-container" ).addClass( "showmodal" );
  } );

  $( "#close" ).click( function ( e ) {
    e.preventDefault();
    $( "body" ).removeClass( "noscroll" );
    $( ".modal-container" ).removeClass( "showmodal" );
  } );

  $( ".modalnav button" ).click( function ( event ) {
    if ( $( this ).hasClass( "leftbtn" ) ) {
      //if the button clicked is the leftbtn one

      if (
        $( ".team-modal" )
        .children()
        .first()
        .hasClass( "active" )
      ) {
        // check if it's the first one
        return false; // and do nothing...
      } else {
        //otherwise...
        $( ".member-modal" ).each( function ( i, el ) {
          // check which team member is active
          if ( $( this ).hasClass( "active" ) ) {
            // one of them will be active, so

            $( this ).removeClass( "active" ); // take its active class away..
            $( this )
              .prev()
              .addClass( "active" ); // grab the previous one and add the active class.

            var temp = $( this ).prev(); // make a temporary variable that can check the previous position
            if ( $( temp ).index() == 0 ) {
              // if this modal is the very first one
              $( ".modalnav .leftbtn" ).css( "opacity", ".25" ); // make it opaque
            } else {
              // otherwise...
              $( ".modalnav .rightbtn" ).css( "opacity", "1" ); // make sure they're not opqaue
              $( ".modalnav .leftbtn" ).css( "opacity", "1" ); //
            }
          }
        } );
      }
    } else if ( $( this ).hasClass( "rightbtn" ) ) {
      if (
        $( ".team-modal" )
        .children()
        .last()
        .hasClass( "active" )
      ) {
        return false;
      } else {
        $( ".member-modal" ).each( function ( i, el ) {
          if ( $( this ).hasClass( "active" ) ) {
            $( this ).removeClass( "active" );
            $( this )
              .next()
              .addClass( "active" );
            var temp = $( this ).next();
            if ( $( temp ).index() == $( ".team-modal" ).children().length - 1 ) {
              $( ".modalnav .rightbtn" ).css( "opacity", ".25" );
            } else {
              $( ".modalnav .rightbtn" ).css( "opacity", "1" );
              $( ".modalnav .leftbtn" ).css( "opacity", "1" );
            }
            return false;
          }
        } );
      }
    }
  } );

  /*****************************************************************************
   ***************   3D Flipbook Plugin + Modals                ****************
   ******************************************************************************/

  $( ".flipbookbtn" ).click( function ( e ) {
    e.preventDefault();
    $( ".flipbook-modal" ).css( "display", "block" );
    window.dispatchEvent( new Event( "resize" ) );
  } );

  $( ".close-flipbook" ).click( function ( e ) {
    e.preventDefault();

    $( ".flipbook-modal" ).css( "display", "none" );
  } );

  /*$( window ).load( function () {
    $( '#font_awesome-css' ).remove();
  } );*/

  // Blog Overview Category filtering
  // ---
  var pageNumber = 1;
  $("#load_more_posts").click(function(e) {
    console.log(e);
    e.preventDefault();
    var button = $(this),
      data = {
        action: "loadmore_blogposts",
        page: pageNumber
      };

    $.ajax({
      // you can also use $.post here
      url: loadmore_params.ajaxurl, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function(xhr) {
        //console.log(xhr);
      },
      success: function(data) {

        if (data) {
          $("#blog-post-container").append(data);
          pageNumber++;
          console.log(pageNumber);

          button.show();

          // if (loadmore_params.current_page == loadmore_params.max_page) {
          //   button.hide(); // if last page, remove the button
          // }
        } else {
          console.log('nomas');
          //button.hide(); // if no data, remove the button as well
          $(".load-more-container").prepend(
            '<p class="no-mas lead">No more results.</p>'
          );
          button.attr("disabled", "disabled");
        }

        //$(".load-more.loading-dots").hide();
      },
      error: function(jqXHR, textStatus, errorThrown) {
        //$("#image").hide();
         console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
      }
    });
  });



  var alm_is_animating = false; // Animating flag

  $( "section.blog-cats a.cat" ).click( function ( e ) {
    e.preventDefault();

    $( "section.blog-cats a.cat" ).removeClass( "active" );

    var el = $( this );

    if ( !el.hasClass( "active" ) && !alm_is_animating ) {
      el.addClass( "active" );
      alm_is_animating = true;

      var data = el.data(), // Get data values from selected menu item
        transition = "fade", // 'slide' | 'fade' | null
        speed = "300";

      $.fn.almFilter( transition, speed, data );
    }
  } );

  $.fn.almFilterComplete = function () {
    alm_is_animating = false;
  };







  // END Main
} );